/**
 * Created by pony.ma@nirvana-info on .
 */
/**
 * Created by pony.ma@nirvana-info on .
 */

export default {
  0: {order: false, slc: false, file: false},
  3: {order: false, slc: false, file: 'item'},
  6: {order: false, slc: false, file: 'date'},
  9: {order: false, slc: 'item', file: false},
  17: {order: false, slc: 'item', file: 'item'},
  18: {order: false, slc: 'item', file: 'date'},
  10: {order: false, slc: 'date', file: false},
  15: {order: false, slc: 'date', file: 'item'},
  16: {order: false, slc: 'date', file: 'date'},
  2: {order: 'item', slc: false, file: false},
  5: {order: 'item', slc: false, file: 'item'},
  8: {order: 'item', slc: false, file: 'date'},
  13: {order: 'item', slc: 'item', file: false},
  26: {order: 'item', slc: 'item', file: 'item'},
  24: {order: 'item', slc: 'item', file: 'date'},
  14: {order: 'item', slc: 'date', file: false},
  25: {order: 'item', slc: 'date', file: 'item'},
  23: {order: 'item', slc: 'date', file: 'date'},
  1: {order: 'date', slc: false, file: false},
  4: {order: 'date', slc: false, file: 'item'},
  7: {order: 'date', slc: false, file: 'date'},
  11: {order: 'date', slc: 'item', file: false},
  22: {order: 'date', slc: 'item', file: 'item'},
  20: {order: 'date', slc: 'item', file: 'date'},
  12: {order: 'date', slc: 'date', file: false},
  21: {order: 'date', slc: 'date', file: 'item'},
  19: {order: 'date', slc: 'date', file: 'date'}
}



// WEBPACK FOOTER //
// ./src/config/suppressionTypeMap.js